import styled from 'styled-components';
import CardForm from 'refactored/features/soForm/steps/card/creditCard/Form/components/CardForm/container';

export default styled(CardForm)``;
